import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Home from "./components/home";
import Cart from "./components/cart";
import Shop from "./components/shop";
import ProductDetail from "./components/productDetail";
import wishlist from "./components/wishlist";
import Account from "./components/account";
import Checkout from "./components/checkout";
import About from "./components/about";
import Contact from "./components/contact";
import "../src/assets/css/fontawesome.min.css";
import "../src/assets/css/bootstrap.min.css";
import "../src/assets/css/magnific-popup.min.css";
import "../src/assets/css/swiper-bundle.min.css";
import "../src/assets/css/style.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


function App() {
  return (
    <Router>
       <ToastContainer />
      <Switch>
        <Route exact path="/" component={Home} />
        <Route exact path="/cart" component={Cart} />
        <Route path="/view" component={ProductDetail} />
        <Route exact path="/checkout" component={Checkout} />
        <Route exact path="/wishlist" component={wishlist} />
        <Route exact path="/account" component={Account} />
        <Route path="/shop" component={Shop} />
        <Route path="/about" component={About} />
          <Route path="/contact" component={Contact} />
      </Switch>
    </Router>
  );
}

export default App;
